import React from 'react';
import './DispatchBoard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import {
    Button,
    FormGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { FormCheckbox } from '../common/forms/FormElements';

export default class DispatchNotificationButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    render() {
        const { showModal } = this.state;

        const {
            todaySelectedOrLater,
            noResponse,
            onNoResponseCheckedChanged,
            isSavingJobStatus,
            onSendNotifications,
        } = this.props;

        if (!todaySelectedOrLater) {
            return null;
        }

        return (
            <>
                <FormGroup id="notificationFormGroup">
                    <label>Notifications</label>
                    <Button
                        type="button"
                        size="sm"
                        color="primary"
                        onClick={this.toggleModal}
                    >
                        <FontAwesomeIcon
                            size="lg"
                            icon={faBolt}
                            className="mr-2"
                        />
                        Send
                    </Button>
                </FormGroup>
                <Modal
                    id="notificationModal"
                    isOpen={showModal}
                    toggle={this.toggleModal}
                    keyboard={false}
                    backdrop="static"
                >
                    <ModalHeader toggle={this.toggleModal}>
                        Send Notifications
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            Please note: while the system will attempt to assign
                            all unassigned equipment to the crew lead,
                            auto-assignment is not guaranteed to work.
                        </div>

                        <FormCheckbox
                            small
                            className="ml-1 mt-2"
                            id="noResponse"
                            name="noResponse"
                            checked={noResponse}
                            onChange={onNoResponseCheckedChanged}
                            labelText="Include employees with no response"
                        />
                    </ModalBody>
                    <ModalFooter>
                        {isSavingJobStatus && (
                            <>
                                <FontAwesomeIcon
                                    icon={faCircleNotch}
                                    className="fa-spin mr-2"
                                    size="lg"
                                />
                                Sending Notifications and Updating Jobs...
                            </>
                        )}
                        {!isSavingJobStatus && (
                            <>
                                <Button
                                    color="secondary"
                                    disabled={isSavingJobStatus}
                                    onClick={this.toggleModal}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    color="primary"
                                    disabled={isSavingJobStatus}
                                    onClick={async () => {
                                        await onSendNotifications();
                                        this.toggleModal();
                                    }}
                                >
                                    Ok
                                </Button>
                            </>
                        )}
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
